import type { FC } from 'react';
import { useCallback } from 'react';

import { useAppDispatch, useAppSelector } from 'features/app/hooks';
import { useTrackedInteractionAction } from 'features/analytics/hooks';
import { CallType } from 'features/call/call-base/enums';
import { callTypeSelector } from 'features/call/call-base/store/selectors';
import { SelfViewSettingsMenuButton } from 'features/local-video/components';
import {
  isLocalVideoEnabledSelector,
  toggleLocalVideo,
} from 'features/local-video/store';

export const SelfViewSettingsMenuButtonContainer: FC = () => {
  const dispatch = useAppDispatch();
  const isLocalVideoEnabled = useAppSelector(isLocalVideoEnabledSelector);

  // TODO: use selector from conference-call feature
  const callType = useAppSelector(callTypeSelector);
  const isConferenceCall = callType === CallType.CONFERENCE_CALL;

  const onInterpreterVideoButtonChange = useCallback(() => {
    dispatch(toggleLocalVideo());
  }, [dispatch]);

  const { onActionClick } = useTrackedInteractionAction({
    actionName: 'self-view-settings-toggle',
    methodName: 'onInterpreterVideoButtonChange',
    eventName: 'NavbarInteraction',
  });

  return (
    <SelfViewSettingsMenuButton
      onClick={() => {
        onInterpreterVideoButtonChange();
        onActionClick();
      }}
      isEnabled={isLocalVideoEnabled}
      isDisabled={isConferenceCall}
    />
  );
};
